/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_DescriptionInputs */



/**
* | output |
* | --- |
* | "Select attributes to paste from clipboard" |
*
* @param {Paste_Attributes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_description = /** @type {((inputs?: Paste_Attributes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez les attributs a coller depuis le presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Attribute aus, die aus der Zwischenablage eingefügt werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona gli attributi da incollare dagli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите атрибуты для вставки из буфера обмена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar atributos para pegar desde el portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要从剪贴板粘贴的属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリップボードから貼り付ける属性を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लिपबोर्ड से पेस्ट करने के लिए एट्रिब्यूट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os atributos que deseja colar da área de transferência.")
	return /** @type {LocalizedString} */ ("Select attributes to paste from clipboard")
});